import React from "react";
import { NoSsr } from "@material-ui/core";
import { ToggleToFavoriteBtn } from "properties/ToggleToFavoriteBtn";
import { MAIN_RESOURCE } from "_common/resources/BaseResourceStore";
import { PROPERTY_PURPOSE, PROPERTY_TYPE, TPropertyCardMdl } from "properties/_models/PropertyMdl";
import { useTranslation } from "react-i18next";
import styles from "./_css/propertyCardTags.module.css";

type Props = {
    property: TPropertyCardMdl;
    isMapCard?: boolean;
};

export default function PropertyCardTags(props: Props) {
    const { t } = useTranslation();

    const displaySoldLabel = props.property.sold && !props.property?.label?.override;
    const displayCustomLabel = !!(props.property?.label?.color && props.property.localized?.label?.text);
    const isFeaturedProperty = !!props.property.isFeatured;

    const renderLabel = () => {
        if (displayCustomLabel) {
            return (
                <div
                    className={styles.tag}
                    style={{
                        backgroundColor: props.property.label.color,
                        color: !props.property.label.fontColor ? "white" : props.property.label.fontColor,
                    }}
                >
                    {props.property.localized.label.text}
                </div>
            );
        }
        if (displaySoldLabel) {
            return (
                <div className={styles.tag}>
                    {props.property.purpose === PROPERTY_PURPOSE.BUY
                        ? props.property.type === PROPERTY_TYPE.condo
                            ? t("property.soldOutCondo")
                            : t("property.soldOut")
                        : t("property.rented")}
                </div>
            );
        }
        return null;
    };

    const propertyType =
        props.property.purpose === PROPERTY_PURPOSE.BUY && props.property.type === PROPERTY_TYPE.condo
            ? t("property.types.condoWithoutApartment")
            : props.property?.isApartment
            ? t("property.types.apartment")
            : t(`property.types.${props.property.type}`);

    return (
        <>
            {!props.isMapCard && (
                <NoSsr>
                    <ToggleToFavoriteBtn item={props.property} type={MAIN_RESOURCE.PROPERTIES} />
                </NoSsr>
            )}
            <div className={styles.tags}>{renderLabel()}</div>
            {isFeaturedProperty && (
                <div className={styles.bottomTags}>
                    <div className={styles.featuredTag}>{t("property.featured")}</div>
                </div>
            )}
            <div className={styles.type}>
                <div className={styles.typeText}>{propertyType}</div>
            </div>
        </>
    );
}
